// Path: ./src/app/pages/CreateUserPage/handleSaveAdminUser.ts
import { UpdateGfAdminUserDto } from "@swagger/typescript-fetch-goflyer";
import { toastError, toastSuccess } from "../../../utils/pageUtil/toast";
import { messages } from "../../../locales/messages";
import { adminApiService } from "../../../utils/api";
import i18n from "i18next";
import { isValidEmail } from "../../../utils/isValidEmail";
import { useLoading } from "../../../contextApi/LoadingContext";
import { useNavigate } from "react-router-dom";
import { SUPERADMIN } from "../../../utils/constant/stringConstant";

export const useHandleSaveAdminUser = () => {
  const { showLoadingScreen } = useLoading();
  const navigate = useNavigate();
  const handleSaveAdminUser = async (updateUser?: UpdateGfAdminUserDto) => {
    const isEditing = Boolean(updateUser?.id);
    if (!updateUser?.userName) {
      toastError(
        `${i18n.t(messages.UserName())} ${i18n.t(messages.is_Empty())}`,
      );
      return;
    }
    if (!updateUser?.email && !isEditing) {
      toastError(`${i18n.t(messages.Email())} ${i18n.t(messages.is_Empty())}`);
      return;
    }
    if (updateUser?.email && !isValidEmail(updateUser.email)) {
      toastError(i18n.t(messages.Incorrect_Email_please_type_correct_email()));
      return;
    }
    if (!updateUser?.password && !isEditing) {
      toastError(
        `${i18n.t(messages.Password())} ${i18n.t(messages.is_Empty())}`,
      );
      return;
    }
    if (!updateUser?.roles?.length) {
      toastError(`${i18n.t(messages.roles())} ${i18n.t(messages.is_Empty())}`);
      return;
    }

    if (
      updateUser?.settingsPage === false &&
      !updateUser?.merchant?.length &&
      updateUser?.roles[0]?.name !== SUPERADMIN
    ) {
      toastError(
        `${i18n.t(messages.merchant())} ${i18n.t(messages.is_Empty())}`,
      );
      return;
    }
    if (
      updateUser?.settingsPage === false &&
      !updateUser?.stores?.length &&
      updateUser?.roles[0]?.name !== SUPERADMIN
    ) {
      toastError(`${i18n.t(messages.stores())} ${i18n.t(messages.is_Empty())}`);
      return;
    }
    if (
      updateUser?.settingsPage === false &&
      !updateUser?.gfFlyerItemCategory?.length &&
      updateUser?.roles[0]?.name !== SUPERADMIN
    ) {
      toastError(
        `${i18n.t(messages.Category())} ${i18n.t(messages.is_Empty())}`,
      );
      return;
    }
    showLoadingScreen(true);

    // Omit settings from the payload passed to the API
    const userPayload = { ...updateUser };
    delete (userPayload as any).settings;
    // Left empty while editing: don't send it, so the current value is kept.
    if (!userPayload.email) delete userPayload.email;
    if (!userPayload.password) delete userPayload.password;

    updateUser.id
      ? await adminApiService.updateOneBaseGfAdminUserAdminControllerGfAdminUser(
          {
            ...userPayload,
            merchant:
              updateUser?.settingsPage === true ||
              updateUser?.roles[0]?.name === SUPERADMIN
                ? []
                : updateUser.merchant,
            stores:
              updateUser?.settingsPage === true ||
              updateUser?.roles[0]?.name === SUPERADMIN
                ? []
                : updateUser.stores,
            gfFlyerItemCategory:
              updateUser?.settingsPage === true
                ? []
                : updateUser.gfFlyerItemCategory,
          },
          updateUser.id,
        )
      : await adminApiService.createOneBaseGfAdminUserAdminControllerGfAdminUser(
          {
            ...userPayload, //This is for optional properties
            userName: updateUser.userName,
            firstName: updateUser.firstName,
            lastName: updateUser.lastName,
            email: updateUser.email,
            password: updateUser.password,
            roles: updateUser.roles,
            merchant:
              updateUser?.settingsPage === true ||
              updateUser?.roles[0]?.name === SUPERADMIN
                ? []
                : updateUser.merchant,
            stores:
              updateUser?.settingsPage === true ||
              updateUser?.roles[0]?.name === SUPERADMIN
                ? []
                : updateUser.stores,
            gfFlyerItemCategory:
              updateUser?.settingsPage === true
                ? []
                : updateUser.gfFlyerItemCategory, //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) will need to find a way to constraint those properties
          },
        );
    showLoadingScreen(false);
    toastSuccess(`Successfully created user`); //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) missing translation here
    navigate(-1);
  };
  return handleSaveAdminUser;
};
